import { FC, MouseEventHandler } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { UseMenuHookOpenMenu } from "@/utils/hooks/useMenu.hook";

export const WidgetQuickActionTrigger: FC<{ onClick: UseMenuHookOpenMenu }> = ({
  onClick,
}) => {
  return (
    <KeyboardArrowDown
      fontSize="small"
      onClick={onClick as MouseEventHandler}
      sx={{ cursor: "pointer", color: "grey.600" }}
    />
  );
};
